<script>
import { mapActions, mapGetters } from 'vuex';
import bem from '@/utils/bem';
import SubNavigation from '@/components/ux/subNavigation/SubNavigation.vue';
import TABS from '@/pages/deliveries/TABS';
import ChangeDelivery from '@/components/modals/Change-delivery.vue';
import companyTabMixin from '@/mixins/companyTabMixin';
import {
  DownOutlined,
  EditOutlined,
} from '@ant-design/icons-vue';

const b = bem('deliveries-page');
const {
  DIGITIZE, CREATE, ENHANCE, ENHANCE_AND_CREATE,
} = TABS;

const DELIVERIES = [
  {
    title: 'Digitize',
    key: 'digitize',
    types: DIGITIZE,
  },
  {
    title: 'Enhance',
    key: 'enhance',
    types: ENHANCE,
  },
  {
    title: 'Create',
    key: 'create',
    types: CREATE,
  },
  {
    title: 'Enhance & Create',
    key: 'enhanceCreate',
    types: ENHANCE_AND_CREATE,
  },
];

const columns = [
  {
    title: 'Display name',
    dataIndex: 'displayName',
    key: 'displayName',
  },
  {
    title: 'Display Text',
    dataIndex: 'displayText',
    key: 'displayText',
  },
  {
    title: 'Hint',
    dataIndex: 'hint',
    key: 'hint',
  },
  {
    title: 'Sub name',
    dataIndex: 'subName',
    key: 'subName',
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
  },
];

export default {
  components: {
    SubNavigation,
    ChangeDelivery,
    DownOutlined,
    EditOutlined,
  },
  mixins: [companyTabMixin],
  data() {
    return {
      deliveries: DELIVERIES,
      columns,
      key: 'digitize',
      name: 'inStoreOrder',
      selectedId: 0,
      showEdit: false,
      sortedDeliveries: [],
      tabTitle: '',
      subTabTitle: '',
      type: 'shipping',
      companyProducts: [],
    };
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      getDeliveriesAction: 'products/getProducts',
      getAllProductsAction: 'products/getAllProducts',
      getCompanyProductsByCompanyIdAction: 'products/getCompanyProductsByCompanyId',
    }),
    openEditWindow(id) {
      this.selectedId = id;
      this.showEdit = true;
    },
    onSelect(key, name) {
      this.key = key;
      this.name = name;
      this.sortedDeliveries = [];
      const sortedKeyDeliveries = this.deliveries.find((item) => item.key === key);
      const typesSortedKeyDeliveries = sortedKeyDeliveries.types;
      this.tabTitle = sortedKeyDeliveries.title;
      const sortedNameAndKeyDeliveries = typesSortedKeyDeliveries
        .find((sortItem) => sortItem.name === name);
      const { productsList, displayName } = sortedNameAndKeyDeliveries;
      this.subTabTitle = displayName;

      this.deliveriesProducts.forEach((item) => {
        if (productsList.includes(item.name)) {
          const companyProduct = this.companyProducts.find((cp) => cp.productId === item.id);
          let displayItem = { ...item };
          if (companyProduct) {
            displayItem = {
              ...displayItem,
              displayName: companyProduct.displayName || displayItem.displayName,
              displayText: companyProduct.displayText || displayItem.displayText,
              subName: companyProduct.subName || displayItem.subName,
              hint: companyProduct.hint || displayItem.hint,
            };
          }

          this.sortedDeliveries = [...this.sortedDeliveries, displayItem];
          this.sortedDeliveries = this.sortedDeliveries.sort((a, c) => a.index - c.index);
        }
      });
    },
    async refreshData() {
      await Promise.all([
        this.getDeliveriesAction(this.type),
        this.getAllProductsAction(),
        this.loadCompanyProducts(),
      ]);
      this.onSelect(this.key, this.name);
    },
    async loadCompanyProducts() {
      if (this.companyId) {
        this.companyProducts = await this.getCompanyProductsByCompanyIdAction(this.companyId);
      }
    },
  },
  async mounted() {
    await this.refreshData();
  },
  computed: {
    ...mapGetters({
      deliveriesProducts: 'products/sortedProductsByIndex',
    }),
  },
  watch: {
    deliveriesProducts() {
      this.onSelect(this.key, this.name);
    },
    async showEdit(val) {
      if (!val) {
        await this.refreshData();
      }
    },
  },
};
</script>

<template>
  <div :class="b()">
    <a-spin :spinning="!isCurrentCompanyLoaded">
      <SubNavigation :company-id="companyId" active-tab="deliveries" />

      <div :class="b('content')">
        <div :class="b('headers')">
          <div :class="b('buttons-menu')">
            <a-dropdown
              :class="b('buttons-menu-item')"
              v-for="delivery in deliveries"
              :key="delivery.key"
            >
              <template #overlay>
                <a-menu>
                  <a-menu-item
                    v-for="item in delivery.types"
                    :key="item.name"
                    @click="this.onSelect(delivery.key, item.name)"
                  >
                    {{ item.displayName }}
                  </a-menu-item>
                </a-menu>
              </template>
              <a-button>
                {{ delivery.title }}
                <DownOutlined />
              </a-button>
            </a-dropdown>
          </div>
          <h2>Active tab: {{ tabTitle }} > {{ subTabTitle }}</h2>
        </div>

        <div v-if="sortedDeliveries && sortedDeliveries.length">
          <a-table
            :columns="columns"
            :dataSource="sortedDeliveries"
            :pagination="false"
          >
            <template #bodyCell="{ column, text, record }">
              <template v-if="column.dataIndex === 'actions'">
                <div :class="b('actions')">
                  <a-button
                    type="primary"
                    html-type="button"
                    @click="openEditWindow(record.id)"
                  >
                    <EditOutlined /> Edit
                  </a-button>
                  <div v-if="showEdit && selectedId === record.id">
                    <change-delivery
                      :type="type"
                      :deliveryKey="key"
                      :delivery="record"
                      :companyId="companyId"
                      v-model:show="showEdit"
                    />
                  </div>
                </div>
              </template>
              <template v-else>
                {{ text || '-' }}
              </template>
            </template>
          </a-table>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<style scoped lang="scss">
.deliveries-page {
  &__content {
    padding: 20px;
    background: #fff;
    border-radius: 4px;
    margin: 0 20px;
  }

  &__headers {
    margin: 20px 0;
    display: flex;
    justify-content: space-between;
  }
  &__buttons-menu-item {
    margin-right: 20px;
  }
  &__actions {
    display: flex;
    justify-content: center;
  }
}
</style>
